class Server {}

module.exports = {
  Server,
};
